export class MemberListItem {
  public id: number;
  public guestName: string;
  public guestEmail: string;
  public reservationTime: Date;
  public status: string;
  public isMember: boolean;
  public eventId: number;
  public guests: Array<MembersGuestsItem>;
  public expanded = false;
  public memberId: number;
  public checked = false;
}
export class EventGuestsResponseModel {
  public guestList: Array<MemberListItem>;
  public waitingList: Array<MemberListItem>;
  // Every row the API returned (id -> its state then). It must go back unchanged with every save: the API
  // deletes only these rows and writes only the ones whose state was changed here.
  public loadedGuests: { [id: number]: string };
}
export class MembersGuestsItem {
  public id: number;
  public guestName: string;
  public guestEmail: string;
  public reservationTime: string;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-database/edit-guests/edit-guests.model.ts